import { Card, Typography } from 'antd';
import { Chart, defaults, registerables } from 'chart.js';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { BarChartModel } from 'models/Reports';
import { useRef } from 'react';
import { Doughnut, getElementAtEvent } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';

interface Props {
  chartData: BarChartModel;
  chartTitle: string;
  isLoading: boolean;
  chartCircumference?: number;
  chartRotation?: number;
  chartCutout?: number;
  handleChartClick: any;
}

const styles: InlineStylesModel = {
  cardBodyStyle: {
    paddingLeft: 50,
    paddingRight: 50,
    paddingTop: 5,
    paddingBottom: 20
  }
};

Chart.register(...registerables);
defaults.font.family = 'Poppins';

export const DoughnutChart = ({ chartData, chartTitle, isLoading, chartCircumference, chartCutout, chartRotation, handleChartClick }: Props): JSX.Element => {
  const chartRef = useRef();
  const nav = useNavigate();

  const handleClick = (event: any) => {
    if (chartRef.current) {
      if (getElementAtEvent(chartRef.current, event).length > 0) {
        const labelDataIndex = getElementAtEvent(chartRef.current, event)[0].index;

        handleChartClick(labelDataIndex);
      }
    }
  };

  return (
    <Card title={<Typography.Title level={4}>{chartTitle}</Typography.Title>} loading={isLoading} bodyStyle={styles.cardBodyStyle}>
      <Doughnut
        onClick={handleClick}
        style={{ maxHeight: 400 }}
        ref={chartRef}
        data={chartData}
        options={{
          circumference: chartCircumference,
          rotation: chartRotation,
          cutout: chartCutout,
          plugins: {
            title: {
              display: false,
              text: chartTitle,
              font: {
                size: 32
              },
              color: 'black'
            },
            legend: {
              display: true,
              position: 'top',
              labels: {
                color: 'black'
              }
            }
          }
        }}
      />
    </Card>
  );
};
